var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-flex',[_c('app-header',{on:{"toggleDrawer":function($event){_vm.drawer = !_vm.drawer}}}),_c('v-flex',{staticClass:"platform-page",class:{'has-drawer': _vm.drawer}},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }